import * as React from 'react';
import ProductLineForm from "../../components/ProductLines/ProductLineForm/ProductLineForm";
var ProductLine = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u0430 \u043B\u0438\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(ProductLineForm, null))))));
};
export default ProductLine;



//////////////////
// WEBPACK FOOTER
// ./src/views/ProductLines/ProductLine.tsx
// module id = 140
// module chunks = 0